<template>
  <a-layout>
    <sider-menu :theme="theme" :menuData="menuData" :collapsed="collapsed" :collapsible="true" />
    <a-layout>
      <global-header :menuData="menuData" :collapsed="collapsed" @toggleCollapse="toggleCollapse"/>
      <a-layout-content :style="{minHeight: minHeight, margin: '24px 24px 0'}">
        <PageLayout :title="title" :desc="desc" :linkList="linkList" :showHeader="showHeader">
          <router-view ref="page" />
        </PageLayout>
      </a-layout-content>
      <a-layout-footer style="padding: 0px">
        <global-footer :link-list="footlinkList" :copyright="copyright" />
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import GlobalHeader from './GlobalHeader.vue';
import GlobalFooter from './GlobalFooter.vue';
import SiderMenu from '../components/menu/SiderMenu.vue';
import PageLayout from './PageLayout.vue';

const minHeight = window.innerHeight - 64 - 24 - 122;

let menuData = [];

export default {
  name: 'MainLayout',
  components: {
    GlobalFooter,
    GlobalHeader,
    SiderMenu,
    PageLayout,
  },
  data() {
    return {
      title: '',
      desc: '',
      linkList: [],
      extraImage: '',
      minHeight: `${minHeight}px`,
      collapsed: false,
      menuData,
      showSetting: false,
      showHeader: false,
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
    theme() {
      return this.$store.state.theme;
    },
    layout() {
      return this.$store.state.layout;
    },
    footlinkList() {
      return this.$store.state.footerLinks;
    },
    copyright() {
      return this.$store.state.copyright;
    },
  },
  mounted() {
    this.getPageHeaderInfo();
  },
  updated() {
    this.getPageHeaderInfo();
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed;
    },
    onDrawerChange(show) {
      this.collapsed = show;
    },
    onMenuSelect() {
      this.toggleCollapse();
    },
    onSettingDrawerChange(val) {
      this.showSetting = val;
    },
    getPageHeaderInfo() {
      this.title = this.$route.meta.title;
      this.desc = this.$route.meta.desc;
      this.showHeader = !this.$route.meta.showHeader;
      const { page } = this.$refs;
      if (page) {
        this.linkList = page.linkList;
        this.extraImage = page.extraImage;
      }
    },
  },
  beforeCreate() {
    console.log(this.$router.options.routes);
    menuData = this.$router.options.routes;
  },
};

</script>

<style lang="less" scoped>
  .setting{
    background-color: #1890ff;
    color: #fff;
    border-radius: 5px 0 0 5px;
    line-height: 40px;
    font-size: 22px;
    width: 40px;
    height: 40px;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  }
</style>
